/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bootstrapClient} from '../api'

export const useMutationBootstrapClient = createReactQueryMutationHook('bootstrapClient', bootstrapClient)
